import { render, staticRenderFns } from "./data5.vue?vue&type=template&id=220a293c&scoped=true&"
import script from "./data5.vue?vue&type=script&lang=js&"
export * from "./data5.vue?vue&type=script&lang=js&"
import style1 from "./data5.vue?vue&type=style&index=1&id=220a293c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a293c",
  null
  
)

export default component.exports